import React from 'react';
import 'react-phone-number-input/style.css';
import { useTranslation } from 'react-i18next';
import PhoneInput, {
  Country,
  parsePhoneNumber,
  PhoneNumber,
  type Value,
} from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

import countryTranslations from '@/components/Form/countries/translations.json';
import { DEFAULT_LANG } from '@/config';
import { COUNTRY_US, DEFAULT_USER_COUNTRY, LANG_EN } from '@/config/appConstants';
import { AppLanguages } from '@/types';

export type SelectPhoneFieldProps = {
  className?: string;
  value?: Value;
  onChange: (value: string, phoneData: PhoneNumber | undefined) => void;
  defaultCountry?: string | undefined;
  onBlur?: (value: any) => void;
  fieldId: string;
  userLang?: AppLanguages;
};

export const SelectPhoneField = ({
  className,
  onChange,
  onBlur,
  value = '' as Value,
  userLang = DEFAULT_LANG as AppLanguages,
  defaultCountry = DEFAULT_USER_COUNTRY,
}: SelectPhoneFieldProps) => {
  const { t } = useTranslation();

  const getPhonePrefixCountry = () => {
    if (defaultCountry === LANG_EN.toUpperCase()) {
      return COUNTRY_US;
    }

    return defaultCountry;
  };

  const onDefaultChange = (event: Value) => {
    const phoneNumber = event ? parsePhoneNumber(event) : undefined;
    onChange(event, phoneNumber);
  };

  return (
    <PhoneInput
      flags={flags}
      labels={countryTranslations[userLang]}
      international
      placeholder={t('Forms.Contact.phone')}
      value={value}
      defaultCountry={getPhonePrefixCountry() as Country}
      onChange={onDefaultChange}
      onBlur={onBlur}
      className={className}
    />
  );
};
